import {
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  IconButton
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactInfoResponse } from '../../Model/contact';
import AccountTable from './AccountTable';
import { CompaniesTable } from './CompaniesTable';
import { LicensesTable } from './LicensesTable';
import OrderTable from './OrderTable';
import ProductsTable from './ProductsTable';
import { SensorsTable } from './SensorsTable';
import Copy from '@mui/icons-material/ContentCopy';
import '../../pages/Contacts/contacts.css';

interface Props {
  contactInfo: ContactInfoResponse | undefined;
  tabulator: any;
  filterSelectOptions: any;
  formatDate: Function;
}

const FormattedContactInfo = ({
  contactInfo,
  tabulator,
  filterSelectOptions,
  formatDate
}: Props) => {
  const [showAccount, setShowAccount] = useState(false);
  const [showOrders, setShowOrders] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showSensors, setShowSensors] = useState(false);
  const [showLicenses, setShowLicenses] = useState(false);
  const [showCompanies, setShowCompanies] = useState(false);
  const { t } = useTranslation();
  // eslint-disable-next-line i18next/no-literal-string
  if (!contactInfo) return <p>Not info available</p>;

  const cInfo = contactInfo;

  const {
    mail,
    name,
    surname,
    phone,
    kyc,
    banned,
    accounts,
    accountsCount,
    ordersInfo,
    boughtProducts,
    sensors,
    sensorsCount,
    licenses,
    licensesCount,
    companies
  } = cInfo;

  return (
    <>
      <div className="d-flex flex-row">
        <div className="flex-column w-50">
          <div className="font-weight-bold my-2">{t('GENERAL_INFO')}</div>
          <div className="pl-2 mt-2">
            <p className="font-witght-normal mb-0">
              {t('NAME_SURNAME')}: {name} {surname}
            </p>
            <p className="font-witght-normal mb-0">
              {t('MAIL')}: {mail}
            </p>
            <p className="font-witght-normal mb-0">
              {t('PHONE')}: {phone}
            </p>
            <p className="font-witght-normal mb-0">
              {t('STATUS')}: {banned ? t('BANNED') : t('NOT_BANNED')}
            </p>
          </div>
        </div>
        <div className="flex-column w-50">
          <div className="font-weight-bold my-2">{t('KYC')}</div>
          <div className="pl-2 mt-2">
            <p className="font-witght-normal mb-0">
              {t('SESSION_ID')}:{kyc.sessionId}
              {kyc?.sessionId && (
                <IconButton
                  onClick={() => {
                    if (kyc?.sessionId) {
                      navigator.clipboard.writeText(kyc?.sessionId);
                    }
                  }}
                >
                  <Copy></Copy>
                </IconButton>
              )}
            </p>
            <p className="font-witght-normal mb-0">Tier: {kyc.tier}</p>
          </div>
        </div>
      </div>
      <hr></hr>
      <Card className="card"  style={{ width: '100%' }}>
        <CardActions>
          <Button fullWidth onClick={() => setShowAccount(!showAccount)}>{`${t(
            'ACCOUNTS'
          )}: ${accountsCount}`}</Button>
        </CardActions>
        <Collapse in={showAccount} timeout="auto" unmountOnExit>
          <CardContent>
            <AccountTable
              accounts={accounts}
              tabulator={tabulator}
              filterSelectOptions={filterSelectOptions}
              formatDate={(value) => formatDate(value)}
            ></AccountTable>
          </CardContent>
        </Collapse>
      </Card>
      <Card className="card"  style={{ width: '100%' }}>
        <CardActions>
          <Button fullWidth onClick={() => setShowOrders(!showOrders)}>{`${t(
            'ORDERS'
          )}: ${ordersInfo.length}`}</Button>
        </CardActions>
        <Collapse in={showOrders} timeout="auto" unmountOnExit>
          <CardContent>
            <OrderTable
              ordersInfo={ordersInfo}
              tabulator={tabulator}
              filterSelectOptions={filterSelectOptions}
            ></OrderTable>
          </CardContent>
        </Collapse>
      </Card>
      <Card className="card"  style={{ width: '100%' }}>
        <CardActions>
          <Button
            fullWidth
            onClick={() => setShowProducts(!showProducts)}
          >{`${t('BOUGHT_PRODUCTS')}: ${boughtProducts.length}`}</Button>
        </CardActions>
        <Collapse in={showProducts} timeout="auto" unmountOnExit>
          <CardContent>
            <ProductsTable
              boughtProducts={boughtProducts}
              tabulator={tabulator}
              filterSelectOptions={filterSelectOptions}
            ></ProductsTable>
          </CardContent>
        </Collapse>
      </Card>
      <Card className="card"  style={{ width: '100%' }}>
        <CardActions>
          <Button fullWidth onClick={() => setShowSensors(!showSensors)}>{`${t(
            'SENSORS'
          )}: ${sensorsCount}`}</Button>
        </CardActions>
        <Collapse in={showSensors} timeout="auto" unmountOnExit>
          <CardContent>
            <SensorsTable
              sensors={sensors}
              tabulator={tabulator}
              filterSelectOptions={filterSelectOptions}
              formatDate={(value) => formatDate(value)}
            ></SensorsTable>
          </CardContent>
        </Collapse>
      </Card>
      <Card className="card"  style={{ width: '100%' }}>
        <CardActions>
          <Button
            fullWidth
            onClick={() => setShowLicenses(!showLicenses)}
          >{`${t('LICENSES')}: ${licensesCount}`}</Button>
        </CardActions>
        <Collapse in={showLicenses} timeout="auto" unmountOnExit>
          <CardContent>
            <LicensesTable
              licenses={licenses}
              tabulator={tabulator}
              filterSelectOptions={filterSelectOptions}
              formatDate={(value) => formatDate(value)}
            ></LicensesTable>
          </CardContent>
        </Collapse>
      </Card>

      <Card className="card"  style={{ width: '100%' }}>
        <CardActions>
          <Button
            fullWidth
            onClick={() => setShowCompanies(!showCompanies)}
          >{`${t('COMPANIES')}: ${companies.length}`}</Button>
        </CardActions>
        <Collapse in={showCompanies} timeout="auto" unmountOnExit>
          <CardContent>
            <CompaniesTable
              companies={companies}
              tabulator={tabulator}
              filterSelectOptions={filterSelectOptions}
            ></CompaniesTable>
          </CardContent>
        </Collapse>
      </Card>
    </>
  );
};

export default FormattedContactInfo;
